export const RADIX_DEC = 10;
export const RADIX_HEX = 16;